import ReactApexChart from "react-apexcharts";
import styles from "./styles.module.scss";
import React from "react";
import { IProjectImplementeds } from "../../../../@types/project/project-implemented.type";
import { formatCurrency } from "../../../../utils/formatCurrency";

interface BarChartImplementedProps {
  projectImplemented: IProjectImplementeds[],
  graphType: number,
}

export const BarChartImplemented: React.FC<BarChartImplementedProps> = ({projectImplemented, graphType}) => { 
  function newArrayNameOrPosition(items: IProjectImplementeds[]){
    const array = [] as string[];
    for (let index = 0; index < items.length; index++) {
      const item = projectImplemented[index];
      if(item.name){
        array.push(item.name);
      } else {
        array.push(item.positionName)
      }
    }
    return array;
  }


  function costGraph(itens: IProjectImplementeds[], type: string){
    return itens.map((x) => {
      switch (type) {
        case "budget":
          return x.budgetPrice
          break;
        case "planned":
          return x.plannedPrice
          break;
        case "implemented":
          return x.implementedPrice
          break;
        default:
          break;
      }
    })
  };

  function hourGraph(itens: IProjectImplementeds[], type: string){
    return itens.map((x) => {
      switch (type) {
        case "budget":
          return x.budgetHours
          break;
        case "planned":
          return x.plannedHours
          break;
        case "implemented":
          return x.implementedHours
          break;
        default:
          break;
      }
    })
  };

  const series = [
    {
      name:  graphType === 0 ? "Custo Contratado" : "Horas Contratadas",
      data: graphType === 0 ? costGraph(projectImplemented, "budget") : hourGraph(projectImplemented, "budget")
    },
    {
      name:  graphType === 0 ? "Custo Planejado" : "Horas Planejadas",
      data: graphType === 0 ? costGraph(projectImplemented, "planned") : hourGraph(projectImplemented, "planned")
    },
    {
      name:  graphType === 0 ? "Custo Alocado" : "Horas Alocadas",
      data: graphType === 0 ? costGraph(projectImplemented, "implemented") : hourGraph(projectImplemented, "implemented")
    }
  ]

  const options = {
    chart:{
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 5,
        borderRadiusApplication: 'end'
      },
    },
    dataLabels: {
      enabled: false
    },
    colors: ['#82B536', '#F5CD47', '#036CBF'],
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: newArrayNameOrPosition(projectImplemented)
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          if (graphType === 0) 
            return formatCurrency(val);
          else 
            return `${val}h`
        }
      },
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          if (graphType === 0) 
            return formatCurrency(val);
          else 
            return `${val}h`
        }
      }
    }
  }

  return (
    <div className={styles.container}>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={300}
          width="100%"
        />
      </div>
      <div id="html-dist"></div>   
    </div>
  );
};
